import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { VerifiedAtlantmLanding } from './types';

export function useVerifiedAtlantmLandingData(): Page<VerifiedAtlantmLanding> {
  return useCurrentPage<Page<VerifiedAtlantmLanding>>();
}
